<template>
    <div class="btn-group btn-group-toggle d-table w-100"
         :class="`btn-group-${size}`"
         data-toggle="buttons">
        <label v-for="option in options"
               v-tooltip="option.tooltip"
               class="btn btn-outline-info radio-buttons-group"
               :class="{
                   [`btn-${size}`]: true,
                   active: option[trackBy] === value,
                   disabled: disabled || option.disabled
               }">
            <input type="radio"
                   name="options"
                   autocomplete="off"
                   :id="id"
                   :disabled="disabled || option.disabled"
                   :value="option[trackBy]"
                   :checked="option[trackBy] === value"
                   @input="$emit('update', option[trackBy])">
            {{ option[label] }}
        </label>
    </div>
</template>

<script>
import {getRandomId} from '@/utils'

export default {
    name: 'AppRadioButtonsGroup',
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        id: {
            type: String,
            required: false,
            default: () => getRandomId()
        },
        size: {
            type: String,
            validator: val => ['sm', 'lg', null].indexOf(val) !== -1,
            default: 'sm'
        },
        label: {
            type: String,
            required: true
        },
        trackBy: {
            type: String,
            required: true
        },
        value: {
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped lang="scss">
.btn-group-toggle {
    width: 100%;
    display: table;
    table-layout: fixed;
}

.radio-buttons-group {
    display: table-cell;
    background: white;
    border: $color-purple-light;

    &.active:not(:disabled) {
        color: white !important;
        background: $color-purple-light !important;
    }

    &:disabled {
        background: #926098 !important;
    }
}
</style>
